import { useQuery } from '@tanstack/react-query';

import { apiGet } from '@/lib/http/client';

export interface LatestRelease {
  version: string | null;
  download_url: string | null;
  size: number | null;
  published_at: string | null;
}

export interface LatestReleaseResponse {
  release: LatestRelease | null;
}

export function useLatestRelease(
  orgId: number | undefined,
  enabled: boolean = true
) {
  return useQuery<LatestReleaseResponse>({
    queryKey: ['ahoy-desktop', 'latest-release', orgId],
    queryFn: () =>
      apiGet<LatestReleaseResponse>(
        `/api/orgs/${orgId}/recall/latest-release/`
      ),
    enabled: enabled && !!orgId,
    // Release cadence is days, not minutes. One-hour staleTime avoids redundant
    // refetches while the 5-minute backend cache handles freshness.
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 1,
  });
}
